import * as types from 'actions/actionTypes';
import initialState from 'reducers/initialState';

export default (state = initialState.productList, action) => {
  switch (action.type) {
    case types.MEAL_SURVEY_PRODUCT_LIST_LOAD.SUCCESS:
      return { ...action.productList };

    case types.LOG_OUT.SUCCESS:
      return initialState.productList;

    default:
      return state;
  }
};
